import React, { useRef, useEffect } from 'react';
import { Dimensions, StyleSheet } from 'react-native';
import RNModal from 'react-native-modalbox';
import PropTypes from 'prop-types';
import Colors from '../colors';
export default function Modal(props) {
  const modalRef = useRef();
  useEffect(() => {
    if (props.active) modalRef.current.open();else modalRef.current.close();
  }, [props.active]);
  return /*#__PURE__*/React.createElement(RNModal, {
    ref: modalRef,
    style: [styles.modalContainer, {
      height: props.height,
      width: props.width
    }],
    position: "center",
    backdrop: props.backdrop,
    backdropColor: props.backdropColor,
    backdropOpacity: props.backdropOpacity,
    swipeToClose: props.swipeToClose,
    disabled: props.disabled,
    onClosed: () => props.activeSetter(false),
    onOpened: () => props.activeSetter(true),
    coverScreen: true
  }, props.children);
}
Modal.propTypes = {
  active: PropTypes.bool,
  activeSetter: PropTypes.func.isRequired,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  backdrop: PropTypes.bool,
  backdropColor: PropTypes.string,
  backdropOpacity: PropTypes.number,
  swipeToClose: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.element
};
Modal.defaultProps = {
  active: false,
  height: 'auto',
  width: 'auto',
  backdrop: true,
  backdropColor: Colors.gray600,
  backdropOpacity: 0.4,
  swipeToClose: true,
  disabled: false,
  children: null
};
const styles = StyleSheet.create({
  modalContainer: {
    maxWidth: Dimensions.get('window').width * 0.8,
    borderRadius: 10
  }
});
//# sourceMappingURL=modal.js.map